import {get, post, postJson} from './axios'

const RESOURCE_BASE_PATH = '/ware'
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/ware'

// 获取商家优惠券信息
export const coupons = p => get(`${RESOURCE_BASE_PATH}/coupons`, p);

